export default function timestamper () {
  const date = new Date
  return date.getTime()
}


// WEBPACK FOOTER //
// ./src/helpers/timestamper.js